var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.btnClasses,style:(_vm.btnStyles),on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.btnContent)+" "),_c('i',{class:_vm.iconClasses})])}
var staticRenderFns = []

export { render, staticRenderFns }